import axios from 'axios';
import React, { useState } from 'react'
import styled from 'styled-components';
import { API_URL } from '../../const/api';
import { PRIMARY } from '../../const/colors';
import { mobile_normal } from '../../const/fonts';
import CheckIcon from '@mui/icons-material/Check';
import ErrorContainer from '../../components/register/ErrorContainer';

const Container = styled.div`
	position: relative;
  flex:1;
	width: 100%;
  margin: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
	> input {
		border: 1px solid ${PRIMARY};
		outline: none;
		background-color: transparent;
		color: #888;
		padding: 0.7rem 1rem;
		font-size: 1rem;
		width: 100%;
    transition: all 0.3s ease;
	}

  input {
    color:  #fff;
  }
  
	 label {
    font-size: 1rem;
		padding: 0 1rem;
    font-weight: bold;
		color: #fff;
	}

  input.hide {
    opacity: 0;
    visibility: hidden;
  }
  input.show {
    opacity: 1;
    visibility: show;
  }

	&:hover {
		input, select {
			border-color: #fff;
		}
	}

  @media screen and (max-width: 2000px) {
	  width: 100%;
    input, label, select, .MuiFormControlLabel-label {
      font-size: 0.8rem;
      margin: 0.2rem 0;
    }

  }
  @media screen and (max-width: 1600px) {
    margin: 0.25rem 1rem;
  }
  @media screen and (max-width: 768px) {
    align-items: center;
    input, label, select {
      font-size: ${mobile_normal};
    }
    margin: 0.8rem auto;
    text-align: center;

    input::placeholder {
      text-align: center;
    }
  }

  > input.error, select.error {
    border-color: #C21010;
  }
  > input.correct, select.correct {
    border-color: #28a745;
  }
`;

const Check = styled(CheckIcon)`
  color: #28a745;
  position: absolute;
  right: 0.5rem;
  top: 1.78rem;
`;

const InputBox = ({val, placeholder, label, handleChange, name, error, errors, setErrors, form, type}) => {
  const [focused, setFocused] = useState(false);
  const [serverError, setServerError] = useState('');

  const handleFocus = async (e) => {
    setFocused(true);
    if(val==='') {
      setServerError("Completa este campo");
      setErrors({...errors, [name]: 1});
    } else {
      
      if(name==='nombre') return;
      if(name==='nueva_password'||name==='verificar_password') {
        const res = await axios.post(API_URL+'validarFormulario', {'clave': val});
        if(res.data.response.error===1) {
            setServerError(res.data.response.tipo);
            setErrors({...errors, [name]: 1});
        } else {
          setServerError(null);
          setErrors({...errors, [name]: 0});

          if(name==='verificar_password') {
            if(val!==form) {
              setErrors({...errors, [name]: 1});
              setServerError('Las contraseñas no coinciden');
            }
          }
        }
      } else {
        const res = await axios.post(API_URL+'validarFormulario', {[name]: val});
        if(res.data.response.error===1) {
            setServerError(res.data.response.tipo);
            setErrors({...errors, [name]: 1});
        } else {
          setServerError(null);
          setErrors({...errors, [name]: 0});
        }
      }
    }
  };
  return (
    <Container>
      <label>{label}</label>
      <input 
        type={type} 
        placeholder={placeholder} 
        value={val} 
        onChange={handleChange}
        onBlur={handleFocus}
        name={name}
        className={((error||serverError) && focused) ? 'error' : (!serverError && focused) ? 'correct' : null}
      />
      {
        (focused && serverError) && <ErrorContainer focused={focused.toString()} error={serverError} />
      }
      {
        (!serverError && focused) && <Check />
      }
    </Container>
  )
}

export default InputBox;